import axios from "axios";
import API_BASE_URL from "./common/common.js";

/** Unread count poll interval in the header (2 minutes). */
export const NOTIFICATION_COUNT_POLL_INTERVAL_MS = 2 * 60 * 1000;

/**
 * Notification calls use a plain axios client (NOT the shared axiosInstance) so they do
 * NOT trigger the Azure AD token-refresh interceptor. This ensures the network tab shows
 * the notification UI services executing directly instead of repeated `token` requests.
 */
const notificationClient = axios.create();

// Attach the existing access token (if any) without forcing a refresh.
notificationClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers["access-token"] = token;
  }
  return config;
});

class NotificationService {
  static getUserId() {
    return localStorage.getItem("employee_uid");
  }

  static async fetchUserNotifications(userId) {
    const response = await notificationClient.get(
      `${API_BASE_URL}/fetchUserNotifications?user_id=${userId}`
    );
    return Array.isArray(response.data) ? response.data : [];
  }

  static async fetchUnreadNotificationCount(userId) {
    const response = await notificationClient.get(
      `${API_BASE_URL}/fetchUnreadNotificationCount?user_id=${userId}`
    );
    return response.data?.unread_count ?? 0;
  }

  static toUserId(userId) {
    const numericId = Number(userId);
    return Number.isFinite(numericId) ? numericId : userId;
  }

  static async markNotificationAsRead(notificationUid, userId) {
    const response = await notificationClient.post(
      `${API_BASE_URL}/markNotificationAsRead`,
      {
        aa_app_notification_uid: notificationUid,
        user_id: this.toUserId(userId),
      }
    );
    return response.data;
  }

  static async deleteNotification(notificationUid, userId) {
    const response = await notificationClient.post(
      `${API_BASE_URL}/deleteNotification`,
      {
        aa_app_notification_uid: notificationUid,
        user_id: this.toUserId(userId),
      }
    );
    return response.data;
  }
}

export default NotificationService;
